module.exports = __webpack_public_path__ + "static/media/car_wash.ceae52fb.svg";